import type {ConvertLeadToClientFormPayload} from "./convert-lead-to-client.schema";

import {convertLeadToClient} from "@project/sdk/sales";
import {ConvertLeadToClientResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {leadKeys, leadMutationKeys} from "../../../lead-keys";

import {convertLeadToClientMapper} from "./convert-lead-to-client.mapper";

export function convertLeadToClientMutationOptions() {
  return mutationOptions({
    mutationFn: async (payload: ConvertLeadToClientFormPayload) =>
      ConvertLeadToClientResponse.parse(
        await convertLeadToClient(payload.leadId, convertLeadToClientMapper.toSdk(payload)),
      ),
    mutationKey: leadMutationKeys.convertLeadToClient,
    onSuccess: async (_clientId, payload, _onMutateResult, {client}) => {
      client.removeQueries({queryKey: leadKeys.detail(payload.leadId)});
      await client.invalidateQueries({queryKey: leadKeys.lists()});
    },
  });
}
